import { type MapProjection, ProjectionNameEnum } from "@mm/metx-workbench.meteomatics.com";

export type ProjectionName = MapProjection["name"] | undefined;

export function isGlobeProjection(projectionName: ProjectionName): boolean {
  return projectionName === ProjectionNameEnum.globe;
}

export function isLambertProjection(projectionName: ProjectionName): boolean {
  return projectionName === ProjectionNameEnum.lambertConformalConic;
}

export function supportsMapboxCustomLayers(projectionName: ProjectionName): boolean {
  // Mapbox custom layers are currently supported only on mercator and globe.
  // Other projections (e.g. lambertConformalConic) skip custom-layer render calls.
  return projectionName === ProjectionNameEnum.mercator || projectionName === ProjectionNameEnum.globe;
}

export function shouldUseProjectionFallback(projectionName: ProjectionName): boolean {
  // Scene "fallback" means: use non-mercator WMS renderer routing.
  // - globe -> binary_fallback (3d custom layer path)
  // - other non-mercator projections -> raster fallback
  // - mercator -> normal binary/wmts/raster routing
  return projectionName !== ProjectionNameEnum.mercator;
}
